import { getTrackBackground, Range } from 'react-range';
import { RenderTrack } from '../Range/Range';
import { Stack } from 'react-bootstrap';
import { FormattedMessageDiv } from '../FormatJSDiv/FormatJSDiv';

type SteppedRangeProps = React.JSX.IntrinsicElements['div'] & {
  steps: string[];
  stepIndex: number;
  progressOffset?: number;
}

export const SteppedRange = ({ className, steps, stepIndex = 0, progressOffset = 0 }: SteppedRangeProps) => {
  if (stepIndex === -1) return null;
  const filteredSteps = steps.filter(step => !step.includes('$'))

  return (
    <div className={"fs-7 " + className}>
      <Stack direction='horizontal' className='justify-content-between'>
      <FormattedMessageDiv className="ps-2 fw-semibold" id={filteredSteps[Math.floor(stepIndex)]}/>
      <div className="pe-2">Step {Math.floor(stepIndex) + 1 + progressOffset} of {filteredSteps.length + progressOffset} </div>
      </Stack>
      <Range
      min={0}
      max={filteredSteps.length - 1}
      values={[stepIndex]}
      renderTrack={({ props, children }) => (
        <RenderTrack props={{...props, trackStyle:{
            height: '19px',
            width: '100%',
            borderRadius: '11px',
            background: getTrackBackground({
              values: [stepIndex],
              colors: ['#000082', '#FFFFFF'],
              min: -.5,
              max: filteredSteps.length - 1
            }),
            alignSelf: 'center',
            border: '4px solid rgb(255, 255, 255)',
            boxShadow: '8px 8px 17px #0000000D',
          }}} sliderValues={[stepIndex]} min={-.5} max={filteredSteps.length - 1}>
          {children}
        </RenderTrack>
      )}
      renderThumb={() => null}
      onChange={()=>{}}
      />
    </div>
  );
};
